import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: `${category.name} - 东升大舞台`,
      description: category.description,
      url: `https://dongshengdawutai.com/category/${slug}`,
      isPartOf: {
        '@type': 'WebSite',
        name: '东升大舞台',
        url: 'https://dongshengdawutai.com/',
      },
    },
  ];

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${category.name} - 东升大舞台${category.name === '下载教程' ? '安卓iOS官方下载安装指南' : category.name === '登录注册' ? '账号注册登录教程' : category.name === '使用指南' ? 'App功能使用教程' : category.name === '常见问题' ? '官方答疑' : '最新动态'}`}
        description={category.description}
        keywords={`东升大舞台${category.name},东升大舞台app,东升大舞台教程`}
        canonicalUrl={`https://dongshengdawutai.com/category/${slug}`}
        schemaData={schemaData}
      />
      <Navbar />
      <main className="pt-20 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <div className="mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              {category.name}
            </h1>
            <p className="text-foreground-600 text-sm md:text-base">
              {category.description} — 共 {categoryArticles.length} 篇文章
            </p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  coverImage={article.coverImage}
                  category={article.category}
                  categoryName={category.name}
                  publishedAt={article.publishedAt}
                  readTime={article.readTime}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-200">
                <i className="ri-file-list-3-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无文章</p>
              <Link to="/" className="inline-block mt-4 text-sm text-primary-600 hover:text-primary-700 cursor-pointer">
                返回首页浏览更多内容
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}